// @flow
import React from 'react'
import { format, isPast, isValid } from 'date-fns'

function Time({ date }: { date: string }) {
  return (
    <time
      dateTime={format(date, 'YYYY-MM-DD')}
      style={
        isPast(date)
          ? {
              textDecoration: 'line-through',
              opacity: 0.4,
            }
          : null
      }
    >
      {format(date, 'D MMMM YYYY')}
    </time>
  )
}

function ShowDate({
  date,
  pastText,
}: {
  date: string | string[],
  pastText?: string,
}) {
  const dates: string[] = Array.isArray(date) ? [...date] : [date]
  if (isPast(dates[dates.length - 1]) && pastText != null) {
    dates.push(pastText)
  }
  return dates.map<React$Node>((d, i) => (
    <React.Fragment key={d}>
      {i === 0 ? null : ' → '}
      {isValid(new Date(d)) ? <Time date={d} /> : d}
    </React.Fragment>
  ))
}

export default ShowDate
